<template>
  <div class="Nav__socials">
    <a
      target="_blank"
      rel="noreferrer nofollow"
      href="https://www.facebook.com/%D0%A6%D0%B5%D0%BD%D1%82%D1%80-%D0%B2%D0%B7%D0%B0%D0%B8%D0%BC%D0%BE%D0%BF%D0%BE%D0%BC%D0%BE%D1%89%D0%B8-%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BDkz-102331558144552"
      class="Nav__social"
    >
      <svg
        width="15"
        height="24"
        viewBox="0 0 15 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.18984 1.91712C6.41735 0.689609 8.0822 0 9.81816 0H13.0909C13.6934 0 14.1818 0.48841 14.1818 1.09091V5.45454C14.1818 6.05702 13.6934 6.54544 13.0909 6.54544H9.81816V8.72726H13.0909C13.4268 8.72726 13.744 8.88202 13.9507 9.14681C14.1575 9.41159 14.2307 9.75685 14.1492 10.0827L13.0583 14.4464C12.9369 14.932 12.5006 15.2727 12 15.2727H9.81816V22.909C9.81816 23.5115 9.32975 24 8.72726 24H4.36362C3.76113 24 3.27272 23.5115 3.27272 22.909V15.2727H1.09091C0.488416 15.2727 0 14.7843 0 14.1818V9.81816C0 9.21567 0.488416 8.72726 1.09091 8.72726H3.27272V6.54544C3.27272 4.80948 3.96233 3.14463 5.18984 1.91712ZM9.81816 2.18182C8.66085 2.18182 7.55094 2.64155 6.73261 3.45989C5.91427 4.27823 5.45454 5.38814 5.45454 6.54544V9.81816C5.45454 10.4206 4.96611 10.9091 4.36362 10.9091H2.18182V13.0909H4.36362C4.96611 13.0909 5.45454 13.5793 5.45454 14.1818V21.8181H7.63634V14.1818C7.63634 13.5793 8.12475 13.0909 8.72726 13.0909H11.1482L11.6937 10.9091H8.72726C8.12475 10.9091 7.63634 10.4206 7.63634 9.81816V6.54544C7.63634 5.96679 7.86622 5.41183 8.27539 5.00267C8.68455 4.59349 9.23951 4.36363 9.81816 4.36363H12V2.18182H9.81816Z"
          fill="#2979FF"
        />
      </svg>
    </a>
    <a
      target="_blank"
      rel="noreferrer nofollow"
      href="https://web.telegram.org/#/im?p=@helpcenterlife"
      class="Nav__social"
    >
      <svg
        width="28"
        height="25"
        viewBox="0 0 28 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.490742 11.9292L7.19726 15.2716C7.45665 15.3996 7.76289 15.3905 8.01086 15.2453L13.9803 11.775L10.3671 14.9768C10.1831 15.1402 10.078 15.3733 10.078 15.619V23.4179C10.078 24.2407 11.1281 24.5869 11.6207 23.9333L14.5197 20.079L21.689 24.1618C22.1918 24.4509 22.8363 24.1607 22.9528 23.5859L27.4242 1.30324C27.5579 0.633615 26.8917 0.0874033 26.2724 0.336512L0.561589 10.3637C-0.128602 10.6334 -0.173168 11.599 0.490742 11.9292ZM25.4359 2.50307L21.5062 22.0855L14.7128 18.2164C14.3426 18.005 13.8661 18.0987 13.6032 18.446L11.7921 20.8537V16.0041L21.5633 7.34698C22.3369 6.66251 21.4479 5.44553 20.5646 5.96432L7.54921 13.5313L2.98754 11.2585L25.4359 2.50307Z"
          fill="#2979FF"
        />
      </svg>
    </a>
    <a
      target="_blank"
      rel="noreferrer nofollow"
      href="https://www.instagram.com/supportonline.kz/"
      class="Nav__social"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.0042 5.83812C8.60117 5.83812 5.84617 8.59604 5.84617 11.9959C5.84617 15.3988 8.60417 18.1538 12.0042 18.1538C15.4072 18.1538 18.1622 15.3958 18.1622 11.9959C18.1622 8.59304 15.4042 5.83812 12.0042 5.83812ZM12.0042 15.9928C9.79517 15.9928 8.00717 14.2039 8.00717 11.9959C8.00717 9.788 9.79617 7.99905 12.0042 7.99905C14.2122 7.99905 16.0012 9.788 16.0012 11.9959C16.0022 14.2039 14.2132 15.9928 12.0042 15.9928Z"
          fill="#2979FF"
        />
        <path
          d="M16.9482 0.0753844C14.7402 -0.0276125 9.27123 -0.0226126 7.06123 0.0753844C5.11923 0.166382 3.40623 0.635367 2.02523 2.01632C-0.282773 4.32425 0.0122273 7.43416 0.0122273 11.995C0.0122273 16.6629 -0.247773 19.7008 2.02523 21.9737C4.34223 24.2896 7.49723 23.9867 12.0042 23.9867C16.6282 23.9867 18.2242 23.9897 19.8592 23.3567C22.0822 22.4937 23.7602 20.5068 23.9242 16.9379C24.0282 14.7289 24.0222 9.26111 23.9242 7.05117C23.7262 2.8383 21.4652 0.283378 16.9482 0.0753844ZM20.4432 20.4468C18.9302 21.9597 16.8312 21.8247 11.9752 21.8247C6.97523 21.8247 4.97023 21.8987 3.50723 20.4318C1.82223 18.7548 2.12723 16.0619 2.12723 11.979C2.12723 6.45419 1.56023 2.47531 7.10523 2.19132C8.37923 2.14632 8.75423 2.13132 11.9612 2.13132L12.0062 2.16132C17.3352 2.16132 21.5162 1.60334 21.7672 7.14717C21.8242 8.41213 21.8372 8.79212 21.8372 11.994C21.8362 16.9359 21.9302 18.9528 20.4432 20.4468Z"
          fill="#2979FF"
        />
        <path
          d="M18.4063 7.03394C19.201 7.03394 19.8453 6.38964 19.8453 5.59485C19.8453 4.80006 19.201 4.15576 18.4063 4.15576C17.6115 4.15576 16.9673 4.80006 16.9673 5.59485C16.9673 6.38964 17.6115 7.03394 18.4063 7.03394Z"
          fill="#2979FF"
        />
      </svg>
    </a>
  </div>
</template>

<script>
export default {
  name: "Socials"
};
</script>
